<template>
  <transition name="dialog-fade" @after-leave="afterLeave">
    <div class="maskg" v-show="visible">
      <div class="main w1200">
        <div class="closeg" @click="handleClose">
          <i class="el-icon-error"></i>
        </div>
        <div class="w750">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Layer',
  props: {
    beforeClose: Function,
    visible: Boolean
  },
  data: function () {
    return {
      closed: false
    }
  },
  methods: {
    afterLeave: function () {
      this.$emit('closed')
    },
    handleClose: function () {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide)
      } else {
        this.hide()
      }
    },
    hide: function (cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false)
        this.$emit('close')
        this.closed = true
      }
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.closed = false
        this.$emit('open')
      } else {
        if (!this.closed) this.$emit('close')
      }
    }
  }
}

</script>
<style scoped>
  .maskg {
    top: 0;
    left: 0;
    width: 100%;
    height: 5000px;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 100
  }

  .maskg .w1200 {
    position: relative
  }

  .closeg {
    width: 50px;
    height: 50px;
    top: 90px;
    right: 0;
    position: absolute
  }

  .closeg i {
    font-size: 40px;
    color: #ffffff;
    cursor: pointer
  }

  .maskg {
    top: 0;
    left: 0;
    width: 100%;
    height: 5000px;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 100
  }

  .maskg .w1200 {
    position: relative
  }

  .closeg {
    width: 50px;
    height: 50px;
    top: 90px;
    right: 0;
    position: absolute
  }

  .closeg i {
    font-size: 40px;
    color: #ffffff;
    cursor: pointer
  }

  .maskg .w750 {
    width: 750px;
    height: 530px;
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -375px;
  }

  @media (max-width: 1440px) {
    .maskg .w750 {
      top: 80px;
    }
  }

  @media (max-width: 1366px) {
    .maskg .w750 {
      top: 0;
    }
  }

  @media (max-width: 1280px) {
    .maskg .w750 {
      top: -30px;
    }
  }

  @media (max-width: 1280px) {
    .maskg .w750 {
      top: -30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialoglayer/Layer.vue